import React from 'react'
import classNames from 'classnames'
import classes from './TopPanel.module.css'
import gridClasses from '../../styles/grid.module.css'

export const TopPanel = ({ title, className, ...props }) => (
    <div className={classNames(classes.topBar, className)} {...props}>
        <div
            className={classNames(
                gridClasses.container,
                gridClasses.containerTransparent
            )}
        >
            <h1 className={classes.topBarTitle}>{title}</h1>
        </div>
    </div>
)
